import { useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { generarReporte } from "../functions/Projects";

const DescargarReportePage = ({ API_URL }) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    async function getDocument() {
      const fase = searchParams.get("fase");
      await generarReporte(API_URL, id, fase ? fase : null);
      window.location.href = `${API_URL}/api/mostrar-reporte/${id}?fase=${
        fase ? fase : ""
      }`;
    }

    getDocument();
  }, []);

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <h2 style={{ textJustify: "center", marginTop: "2rem" }}>
        Generando el reporte...
      </h2>
    </div>
  );
};

export default DescargarReportePage;
